import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { REQUEST_LIFE_CICLE } from 'interfaces/requests';
import { MICROSERVICES, get } from 'api';
import endpoints from './endpoint';
import { openAlert } from 'modules/alertHandler';
import { IStrategyRegister } from 'components/StrategyRegister/interfaces';
import {
  ISimulation,
  ISimulationResponse,
} from 'components/StrategiesList/SimulationDetailPopUp/DetailTable/interfaces';

import { getParsedSimulation, getSimulationChangeOnlyHeaders } from './helpers';
import { store } from 'store';

interface ISimulationState {
  loading: REQUEST_LIFE_CICLE;
  current?: ISimulation;
  list?: {
    [strategyIdKey: string]: ISimulation;
  };
}

const initialState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  current: undefined,
} as ISimulationState;

export const loadSimulationAction = createAsyncThunk<
  ISimulation,
  { strategyId: string; forceLoadCompleteSimulation?: boolean },
  { rejectValue: IStrategyRegister }
>(
  'simulation/show',
  async (
    { strategyId, forceLoadCompleteSimulation },
    { rejectWithValue, dispatch },
  ) => {
    const currentSimulation = store.getState().simulation.current;
    try {
      const response = await get<ISimulationResponse[]>(
        MICROSERVICES.DISTRIBUTIONS,
        {
          url: endpoints.loadSimulation(strategyId),
        },
      );
      const simulationDistribution = response.data.values[0];

      const isSameSimulation =
        currentSimulation?._id === simulationDistribution?._id;
      return isSameSimulation && !forceLoadCompleteSimulation
        ? getSimulationChangeOnlyHeaders(
            currentSimulation,
            simulationDistribution,
          )
        : getParsedSimulation(simulationDistribution);
    } catch (error) {
      dispatch(
        openAlert({
          title: 'Erro!',
          content:
            'Ocorreu algum problema e não foi possível mostrar a simulação.',
        }),
      );
      console.error(`error at show simulation ${strategyId}`, error);
      return rejectWithValue(error);
    }
  },
);

const simulationModeSlice = createSlice({
  name: 'simulation',
  initialState,
  reducers: {
    resetSimulationAction(state) {
      state = Object.assign({}, initialState);
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSimulationAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(loadSimulationAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      return state;
    });
    builder.addCase(loadSimulationAction.fulfilled, (state, { payload }) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.current = payload;
      return state;
    });
  },
});
const { reducer, actions } = simulationModeSlice;
export const { resetSimulationAction } = actions;
export default reducer;
